export const UPDATE_FILTER = 'UPDATE_FILTER';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const UPDATE_SEARCH = 'UPDATE_SEARCH';
export const UPDATE_SEARCH_FIELD = 'UPDATE_SEARCH_FIELD';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
